/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:no-magic-numbers

import { BitSet } from '../bit-set';
import { DataMapper } from './data-mapper';

export class BitSetMapper<Enum> implements DataMapper<BitSet<Enum>, string> {
  constructor(private length: number = 64) {
  }

  serialize(obj: BitSet<Enum>): string {
    return parseInt(obj.toString(), 16).toString();
  }

  deserialize(hex: string): BitSet<Enum> {
    return new BitSet(this.length, parseInt(hex).toString(16));
  }

}
